import {Component, Input, Self, OnInit, OnChanges} from '@angular/core';
import { NgControl} from "@angular/forms";

@Component({ selector: '', template: '', styleUrls: [] })

export class FormGroupBaseComponent implements OnInit, OnChanges {

  @Input() id: string='';
  @Input() class: string='';
  @Input() editable: boolean=true;
  @Input() required: boolean=false;
  @Input() submitted: boolean=false;
  @Input() valueIfEmpty: string='-';
  @Input() labelCaption: string='';
  @Input() labelClass: string='';
  @Input() labelStacked: boolean=false;
  @Input() inputClass: string='';
  @Input() tabIndex: number=null;
  @Input() sm: boolean=false; // Condensed height
  @Input() disabled: boolean=false;

  constructor(@Self() public ngControl: NgControl) {
    this.ngControl.valueAccessor = this;
  }
  ngOnInit(): void {
    if(this.id==undefined) this.id='id';
    if(this.sm==undefined) this.sm=false;
    if(this.editable==undefined) this.editable=true;
    if(this.submitted==undefined) this.submitted=false;
    if(this.labelStacked==undefined) this.labelStacked=false;
    if(this.tabIndex==undefined) this.tabIndex=null;
    if(this.disabled==undefined) this.disabled=false;
    this.updateDisabledState();
  }
  ngOnChanges(): void {
    this.updateDisabledState();
  }
  // Synchronizes the disabled Input with the FormControl's actual disabled state.
  // This is the correct way to disable a native form element bound via [formControl]:
  // Angular's built-in ControlValueAccessor (registered on the inner native element,
  // which is bound to this same control) reacts to control.disable()/.enable() through
  // its own setDisabledState() hook. Binding a plain [disabled] attribute directly on
  // that same element would conflict with this mechanism and get silently overwritten.
  updateDisabledState(): void {
    if(!this.ngControl || !this.ngControl.control) return;
    if(this.disabled && !this.ngControl.control.disabled)
      this.ngControl.control.disable({ emitEvent: false });
    else if(!this.disabled && this.ngControl.control.disabled)
      this.ngControl.control.enable({ emitEvent: false });
  }
  public getDataValue() {
    return !this.ngControl.control.value ? this.valueIfEmpty : this.ngControl.control.value;
  }

  //ControlValueAccessor interface
  writeValue(obj: any) {  }
  registerOnChange(fn: any) { }
  registerOnTouched(fn: any) { }
  setDisabledState?(isDisabled: boolean) { }
}
